import { call, put, takeLatest } from 'redux-saga/effects';
import { graphql } from '../../../globals/api/requests';

import actions, {
  RENAME_LIST_REQUEST,
  RENAME_LIST_SUCCESS,
} from '../actions/lists';

import { fetchMe } from '../../account/requests';
import userActions from '../../account/actions';

export function* renameList({ id, name }) {
  try {
    const response = yield call(
      graphql,
      `mutation listRename($id: Int!, $name: String!) {
        listRename(id: $id, name: $name) {
          success
        }
      }`,
      {
        id,
        name,
      }
    );

    if (response.errors) {
      yield put(actions.renameListError(response.errors[0]));
      return false;
    }

    if (response.data.listRename.success) {
      yield put(actions.renameListSuccess({ id, name }));
    }
  } catch (error) {
    yield put(actions.renameListError(error));
    return false;
  }

  return true;
}

// Fetch user data again to update the new list name across the app
function* updateUserData() {
  try {
    const response = yield call(fetchMe);

    yield put(userActions.userReceive(response.me));
  } catch (error) {
    yield put(actions.renameListError(error));
  }
}

function* mySaga() {
  yield takeLatest(RENAME_LIST_REQUEST, renameList);
  yield takeLatest(RENAME_LIST_SUCCESS, updateUserData);
}

export default mySaga;
